const layoutMap = {
  // eslint-disable-next-line boundaries/element-types -- FIXME
  light: () => import('libs/components-theme-picker/legacy/assets/light-layout.svg'),
  // eslint-disable-next-line boundaries/element-types -- FIXME
  dark: () => import('libs/components-theme-picker/legacy/assets/dark-layout.svg'),
  // eslint-disable-next-line boundaries/element-types -- FIXME
  system: () => import('libs/components-theme-picker/legacy/assets/system-layout.svg'),
};

export const resolveLayoutAsset = (name: 'light' | 'dark' | 'system'): Promise<string> =>
  layoutMap[name]().then(module => module.default);
